import React, { useState } from "react";
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CButton,
  CForm,
} from "@coreui/react";
import { Image } from "react-bootstrap";
import crossIcon from "../../../assets/images/cross-icon-custom.png";

const ShareTrakingModal = (props) => {
  const [mapState, setMapState] = useState("normal");

  const handleRadioChange = (e) => {
    let { value } = e.target;
    setMapState(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const satelliteUrl =
      process.env.REACT_APP_SATELLITE_VIEW +
      props?.shareLocation.latitude +
      "," +
      props?.shareLocation.longitude;
    const normalUrl =
      process.env.REACT_APP_NORMAL_VIEW +
      props?.shareLocation.latitude +
      "," +
      props?.shareLocation.longitude;
    mapState == "normal" ? window.open(normalUrl) : window.open(satelliteUrl);
    props?.setOpenShareTrakingModal(false);
  };

  return (
    <CModal
      className="shareTrakingModal"
      backdrop="static"
      size="sm"
      visible={props?.openShareTrakingModal}
      onClose={() => props?.setOpenShareTrakingModal(false)}
      alignment="center"
    >
      <CModalHeader closeButton={false}>
        <CModalTitle>Map Layers</CModalTitle>
        <button
          className="custom-close-btn"
          onClick={() => props.setOpenShareTrakingModal(false)}
        >
          <Image src={crossIcon} alt="material-symbols-info-icon" />
        </button>
      </CModalHeader>
      <CModalBody className="mt-2">
        <CForm
          action="#"
          className="add_device_form needs-validation"
          noValidate
        >
          <div className="shareTrakingModal-inputs radio-group gap-15">
            <label>
              <input
                type="radio"
                id="slot1"
                name="radioBtn"
                value="normal"
                onChange={(e) => handleRadioChange(e)}
                checked={mapState == "normal"}
                required
              />
              Terrain
            </label>
            <label>
              <input
                type="radio"
                id="slot2"
                name="radioBtn"
                value="satellite"
                onChange={(e) => handleRadioChange(e)}
                checked={mapState == "satellite"}
                required
              />
              Satellite
            </label>
          </div>
          <div
            className="submit-btn mt-3"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CButton
              type="submit"
              style={{ marginTop: "5px", background: "rgb(60 75 100 / 93%)" }}
              onClick={(e) => handleSubmit(e)}
            >
              Confirm
            </CButton>
          </div>
        </CForm>
      </CModalBody>
    </CModal>
  );
};

export default ShareTrakingModal;
